import { useEffect, useState } from "react";
import { http } from "@/lib/api";
import JsonLd from "@/components/JsonLd";

/**
 * SeoBlock — 100% ONZICHTBAAR component.
 * Injecteert alle SEO-signalen zonder ook maar één pixel te renderen:
 *  1. <meta name="keywords"> in <head>
 *  2. <meta name="description"> in <head>
 *  3. <link rel="alternate" hreflang="..."> voor internationale rollout
 *  4. JSON-LD ItemList voor Google Rich Results (long-tail structured data)
 *
 * De keyword-database wordt volledig backend-gestuurd — deze component render
 * geen zichtbare inhoud op de pagina.
 */
export default function SeoBlock() {
  const [top, setTop] = useState({});
  const [meta, setMeta] = useState(null);

  useEffect(() => {
    http.get("/seo/top-by-cluster?limit=10").then((r) => setTop(r.data)).catch(() => {});
    http.get("/seo/meta?page=home").then((r) => setMeta(r.data)).catch(() => {});
  }, []);

  useEffect(() => {
    if (!meta) return;
    // Inject <meta name="keywords">
    let el = document.querySelector('meta[name="keywords"]');
    if (!el) { el = document.createElement("meta"); el.name = "keywords"; document.head.appendChild(el); }
    el.content = (meta.keywords || []).join(", ");
    // Inject / update <meta name="description">
    let d = document.querySelector('meta[name="description"]');
    if (!d) { d = document.createElement("meta"); d.name = "description"; document.head.appendChild(d); }
    d.content = meta.description || "";
  }, [meta]);

  const allKeywords = Object.values(top || {}).flat().map((k) => k.keyword);
  const itemListLd = {
    "@context": "https://schema.org", "@type": "ItemList",
    "name": "Woon Verder — Alle woonsituaties",
    "numberOfItems": allKeywords.length,
    "itemListElement": allKeywords.slice(0, 150).map((kw, i) => ({
      "@type": "ListItem", "position": i + 1, "name": kw,
      "url": `https://woonverder.eu/woningen?kw=${encodeURIComponent(kw)}`
    }))
  };

  return <JsonLd data={itemListLd} id="ld-itemlist-seo" />;
}
